// ** React Imports

import { Link } from 'react-router-dom'

const Error500 = () => {
  return (
    <>
      <h1 className='text-9xl font-extrabold text-black tracking-widest'>
        500
      </h1>
      <h2 className='text-4xl mt-4 mb-2'>Internal server error 👨🏻‍💻</h2>
      <span>Oops, something went wrong!</span>
      <div className='text-center pt-1 pb-1 mt-12'>
        <Link
          className='bg-blue-500 inline-block px-6 py-2.5 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out w-full mb-3'
          type='button'
          to='/'
        >
          Go To Home
        </Link>
      </div>
    </>
  )
}

export default Error500
